import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as DOMPurify from "dompurify";

import "@styles/readers.scss";

import { Div, Icon } from "@components/Generics.react";

export default function HTMLReader(props) {
    const { deck, closeDeck, recordAttempt } = props;
    const { t } = useTranslation("common");

    //---------------------------------------------------------------------------
    // Completion Tracking
    //---------------------------------------------------------------------------
    useEffect(() => {
        recordAttempt({
            viewedPercentage: 100,
            completion: true,
            pointsDelta: 0,
            score: null,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ========================= Render Function =================================
    return (
        <Div fullht centered compact noOverflow relative>
            <Div
                padTop
                className="html-reader"
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(deck.content),
                }}
            />
            <Div className="close-icon" onClick={closeDeck}>
                {t("deck.close")} <Icon name="close" inline fitted />
            </Div>
        </Div>
    );
}
